import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CardModal from './CardModal';
import { API_URL } from '../config';

function MyCards({ user }) {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedCard, setSelectedCard] = useState(null);

  useEffect(() => {
    fetchCards();
  }, [user.id]);

  const fetchCards = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/users/${user.id}/cards`);
      setCards(response.data.cards || []);
    } catch (err) {
      setError(err.response?.data?.error || 'Errore nel caricamento delle tue carte');
      console.error('Error fetching my cards:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h2>Caricamento delle tue carte...</h2>
      </div>
    );
  }

  return (
    <div className="gallery-container">
      <div className="gallery-header">
        <div className="gallery-header-top">
          <h2>🃏 Le mie carte ({cards.length})</h2>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      {cards.length === 0 ? (
        <div className="no-results">
          <p>Non hai ancora carte. Vinci un'asta per iniziare la collezione.</p>
        </div>
      ) : (
        <div className="cards-clean-grid">
          {cards.map(card => (
            <div key={card.id} className="card-clean" onClick={() => setSelectedCard(card)}>
              {card.jpeg_filename && (
                <img
                  src={`${API_URL}/cards/${card.jpeg_filename}`}
                  alt={card.name}
                  className="card-clean-image"
                />
              )}
            </div>
          ))}
        </div>
      )}

      {selectedCard && (
        <CardModal
          card={selectedCard}
          onClose={() => setSelectedCard(null)}
        />
      )}
    </div>
  );
}

export default MyCards;
